import { render, staticRenderFns } from "./ChooseAppearanceConstrain.vue?vue&type=template&id=5265b663&scoped=true"
import script from "./ChooseAppearanceConstrain.vue?vue&type=script&lang=js"
export * from "./ChooseAppearanceConstrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265b663",
  null
  
)

export default component.exports